import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c894788")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "array-bar",
    style: {
            width: `${_ctx.barWidth}px`,
            height: `${_ctx.arrayElement.barHeight}px`,
            backgroundColor: _ctx.arrayElement.barColor,
            fontSize: '0.75rem',
        }
  }, _toDisplayString(_ctx.barWidth >= 20 ? _ctx.arrayElement.number : ""), 5))
})